export default __webpack_public_path__ + "static/media/boris-misevic-HofOYDPOIdA-unsplash.e7933ab7.jpg";